import { Component, Input } from '@angular/core';

type RatingsColor = 'green' | 'red' | 'amber' | 'orange' | 'yellow' | 'high' | 'medium' | 'low' | '';

@Component({
  selector: 'vrm-risk-rating-compare-widget',
  template: `
    <div
      class="risk-rating-compare"
      *ngIf="ratingColor === 'green' || ratingColor === 'low'"
      [style.background-color]="ratingColor"
      fxLayout="row"
      fxLayoutAlign="center center"
    >
      <mat-icon>check</mat-icon>
    </div>

    <mat-icon
      class="amber-icon"
      *ngIf="
        ratingColor === 'orange' || ratingColor === 'yellow' || ratingColor === 'amber' || ratingColor === 'medium'
      "
    >
      remove_circle
    </mat-icon>

    <mat-icon class="red-icon" *ngIf="ratingColor === 'red' || ratingColor === 'high'">error</mat-icon>
  `,
  styles: [
    `
      .risk-rating-compare {
        height: 45px;
        width: 45px;
        border-radius: 50%;
        color: white;
      }
      .risk-rating-compare > mat-icon {
        font-size: 35px;
        width: 35px;
        height: 35px;
      }

      .amber-icon {
        color: orange;
        font-size: 50px;
        width: 50px;
        height: 50px;
      }
      .red-icon {
        color: red;
        font-size: 50px;
        width: 50px;
        height: 50px;
      }
    `,
  ],
})
export class RiskRatingComparisonWidgetComponent {
  @Input() ratingColor: RatingsColor = '';
}
